import Cookies from "js-cookie";

export const JWT_COOKIE_NAME = "auth_token";

const SHOULD_COOKIE_BE_SECURED = window.location.protocol === "https:";

// use js-cookie Cookies class to setup a basic cookie helper class
export default class Cookie {
  static set(name, value, options = {}) {
    if (typeof document !== "undefined") {
      Cookies.set(name, value, {
        ...options,
        sameSite: "strict",
        path: "/",
        secure: SHOULD_COOKIE_BE_SECURED,
        expires: 7,
      });
    }
  }

  static get(name) {
    if (typeof document !== "undefined") {
      return Cookies.get(name);
    }
  }

  static remove(name, options = {}) {
    if (typeof document !== "undefined") {
      Cookies.set(name, "", {
        ...options,
        expires: -1,
      });
    }
  }
}
